module.exports = __webpack_public_path__ + "img/north-map.4e5db299.png";